module.exports = __webpack_public_path__ + "img/Note.cf14f71b.svg";